import { ProfitLossTableReportSection } from "@common/dto/reports/reports-common.dto";

export const ProfitLossSectionsOrder = [
    ProfitLossTableReportSection.INCOME,
    ProfitLossTableReportSection.COGS,
    ProfitLossTableReportSection.GROSS_PROFIT,
    ProfitLossTableReportSection.EXPENSES,
    ProfitLossTableReportSection.NET_OPERATING_INCOME,
    ProfitLossTableReportSection.OTHER_INCOME,
    ProfitLossTableReportSection.OTHER_EXPENSES,
    ProfitLossTableReportSection.NET_OTHER_INCOME,
    ProfitLossTableReportSection.NET_INCOME,
] as const;
